import React from 'react';

const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);

    const sortedItems = React.useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
            const compareKey = sortConfig.sortKey ?? sortConfig.key;
            sortableItems.sort((a, b) => {
                if (a[compareKey] < b[compareKey]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                else if (a[compareKey] > b[compareKey]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return sortConfig.direction === 'descending' ? 1 : -1;
            });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (sort, key, sortKey) => {
        let direction = 'ascending';
        if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === 'ascending'
        ) {
            direction = 'descending';
        };
        if (sort) {
            setSortConfig({ key, sortKey, direction });
        }
    };


    return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableData;